import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LoginService, UserInfoDto } from '@uoa/auth';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly loginService = inject(LoginService);

  loggedIn$: Observable<boolean>;
  hideLeavePopup = false;
  user$: Observable<UserInfoDto>;
  constructor() {
    this.initialise();
  }

  private initialise(): void {
    void this.loginService.isAuthenticated();

    this.loggedIn$ = this.loginService.loggedIn$;
    this.user$ = this.loginService.userInfo$;
  }
}
